import { useEffect, useState } from "react";
import { useGetContext } from "@onefront/forrestjs-react-root";
import { buildUrl } from "../utils/build-url";
import { useAuth } from "../../service-auth/state/use-auth";

export const useJumpUrl = (target, { lazy = false } = {}) => {
  const proxyBaseUrl = useGetContext("one.axios.proxy.baseUrl");
  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const { sessionData } = useAuth();

  const redirectUrl = `redirect?to=${encodeURIComponent(
    buildLogicUrl(target, sessionData)
  )}`;

  const fetch = () => {
    setLoading(false);
    setLoaded(true);
  };

  useEffect(() => {
    if (lazy) {
      return;
    }

    fetch();
  }, [lazy]);

  return {
    loading,
    loaded,
    error: null,
    url: loading
      ? null
      : buildUrl({ target, proxyBaseUrl, stringToJoin: redirectUrl }),
    fetch
  };
};

const buildLogicUrl = (target, sessionData) => {
  const [appId, deepLink] = target.split("://");
  const data = sessionData ? { state: btoa(JSON.stringify(sessionData)) } : {};
  const urlParams = new URLSearchParams({
    ...{
      serviceId: appId
    },
    ...data
  });

  if (deepLink) urlParams.append("deepLink", `/${deepLink}`);

  const url = `loginApi://jump?${urlParams.toString()}`;
  return url;
};
